module.exports = __webpack_public_path__ + "img/afflilation_icn.660a895a.png";